/* hs-eslint ignored failing-rules */
/* eslint-disable react/prop-types */

'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["validLanguages", "optionsFilter", "multi", "enableSelectAll"];
import I18n from 'I18n';
import { Select } from 'foundations-components/transitional/components/Select';
import PropTypes from 'prop-types';
import { getLanguageOptions, getOptionsForValidLanguages } from '../internal/utils/getLanguageOptions';
import { jsx as _jsx } from "react/jsx-runtime";
const LanguageSelect = props => {
  const {
      validLanguages,
      optionsFilter,
      multi,
      enableSelectAll
    } = props,
    passThroughProps = _objectWithoutPropertiesLoose(props, _excluded);
  const options = validLanguages ? getOptionsForValidLanguages({
    validLanguages,
    optionsFilter
  }) : getLanguageOptions({
    optionsFilter
  });
  const optionsWithSelectAll = [{
    text: I18n.text('i18nAddon.selectAllOptions'),
    selectAll: true,
    options
  }];
  return /*#__PURE__*/_jsx(Select, Object.assign({}, passThroughProps, {
    multi: enableSelectAll || multi,
    anchorType: "button",
    options: enableSelectAll ? optionsWithSelectAll : options
  }));
};
LanguageSelect.propTypes = {
  optionsFilter: PropTypes.func,
  validLanguages: PropTypes.array,
  enableSelectAll: PropTypes.bool
};
export default LanguageSelect;